/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {ingestSearchEntities} from '../api'

export const useMutationIngestSearchEntities = createReactQueryMutationHook('ingestSearchEntities', ingestSearchEntities)
